import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { datadogRum } from '@datadog/browser-rum';
import { useCallback, useContext } from 'react';
import COOKIES from '~/constants/cookies';
import { useIsNative } from '~/context/common/DeviceContext';
import UserContext from '~/context/common/UserContext';
import { BrowserCookies } from '~/utilities';

export function useLandedTrackEvent() {
  const { trackEvent } = useContext(AnalyticsContext);
  const isNative = useIsNative();

  return useCallback(
    (isInViewFromNativeEvent = false) => {
      if (
        isNative &&
        !isInViewFromNativeEvent &&
        BrowserCookies.getJSON(COOKIES.nativeHomeInView) === null
      ) {
        datadogRum.addAction('isInView in native is null', {
          doesCookieExist: !!BrowserCookies.get(COOKIES.nativeHomeInView),
          cookieValue: BrowserCookies.getJSON(COOKIES.nativeHomeInView)
        });
      }

      trackEvent(
        'Viewed - Home Feed',
        {
          isInView: isNative
            ? isInViewFromNativeEvent ||
              BrowserCookies.getJSON(COOKIES.nativeHomeInView)
            : null
        },
        undefined,
        {
          useFetch: true,
          fetchOption: { keepalive: false }
        }
      );
    },
    [isNative, trackEvent]
  );
}

export default function useSendViewedEvent() {
  const {
    userState: { isLoaded: isUserLoaded }
  } = useContext(UserContext);
  const landedTrackEvent = useLandedTrackEvent();

  useEffectOnce(
    () => {
      landedTrackEvent();
    },
    [landedTrackEvent],
    isUserLoaded
  );

  return landedTrackEvent;
}
